import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO component for managing page meta tags
 */
const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  twitterCard = 'summary_large_image',
  twitterTitle,
  twitterDescription,
  twitterImage,
  noindex = false,
  nofollow = false,
  structuredData
}) => {
  const siteTitle = 'ABC Railing - The ABCs of Strong, Safe Metal Railings';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = 'ABC Railing provides high-quality metal railings for residential and commercial applications. Find installation guides, maintenance tips, and product information.';
  
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || 'aluminum railings, steel railings, metal railings, railing installation, railing maintenance, metal staircases, spiral staircases, vinyl decking, ABC Railing';
  
  // Open Graph defaults
  const ogTitleFinal = ogTitle || title || siteTitle;
  const ogDescriptionFinal = ogDescription || metaDescription;
  const ogImageFinal = ogImage || '/logo192.png';
  const ogUrlFinal = ogUrl || (typeof window !== 'undefined' ? window.location.href : '');
  
  // Twitter defaults
  const twitterTitleFinal = twitterTitle || ogTitleFinal;
  const twitterDescriptionFinal = twitterDescription || ogDescriptionFinal;
  const twitterImageFinal = twitterImage || ogImageFinal;
  
  // Robots meta
  const robotsContent = [];
  if (noindex) robotsContent.push('noindex');
  if (nofollow) robotsContent.push('nofollow');
  const robotsMeta = robotsContent.length > 0 ? robotsContent.join(', ') : 'index, follow';

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content={robotsMeta} />
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph meta tags */}
      <meta property="og:title" content={ogTitleFinal} />
      <meta property="og:description" content={ogDescriptionFinal} />
      <meta property="og:image" content={ogImageFinal} />
      <meta property="og:url" content={ogUrlFinal} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ABC Railing" />
      
      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitleFinal} />
      <meta name="twitter:description" content={twitterDescriptionFinal} />
      <meta name="twitter:image" content={twitterImageFinal} />
      
      {/* Structured data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;